import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flag'
})
export class FlagPipe implements PipeTransform {
  
  transform(code: string): string {
    return `assets/flags/${code}.svg`;
  }

}
